<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>订单管理</el-breadcrumb-item>
			<el-breadcrumb-item>待收货</el-breadcrumb-item>
		</el-breadcrumb>

		<el-form :inline="true" :model="item" class="search">
			<el-form-item label="订单号">
				<el-input v-model="item.order_sn" placeholder="请输入订单号" size="small"></el-input>
			</el-form-item>
			<el-form-item label="订单来源">
				<el-cascader v-model="item.supplier_id" :options="options"
							 :props="{ checkStrictly: true, label: 'name',value:'id' }" size="small"
							 clearable></el-cascader>
			</el-form-item>
			<el-form-item label="时间">
				<el-date-picker size="small" style="margin-left: 10px" v-model="item.times" type="daterange"
								range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
				</el-date-picker>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="submit" size="medium">查询</el-button>
			</el-form-item>
		</el-form>
		<!--		数据是list 通过list展示-->
		<div class="list-box" :data="list">
			<div class="list-box-title">
				<span>商品</span>
				<span>所属</span>
				<span>买家</span>
				<span>支付/配送</span>
				<span>实付款</span>
				<span>操作</span>
				<span>状态</span>
			</div>
			<div class="list-box-content">
				<div class="list" v-for="list in list">
					<div class="list-title">
						<span>{{list.created_date}}</span>
						<span>订单编号：{{list.order_sn}}</span>
					</div>
					<div class="list-content-box">
						<div class="list-content">
							<div class="different-box">
								<div class="different" v-for="attr in list.goods">
									<div class="thumb">
										<img :src="attr.pic_url" width="70px" height="70px" style="height: 70px">
										<div class="goods-text">
											<span>{{attr.product_name}}</span>
											<span>{{attr.sku_name}}</span>
										</div>
									</div>
									<div>
										<span>￥{{attr.price}} </span>
										<span>&nbsp;x&nbsp;{{attr.number}}</span>
									</div>
									<div>
										<span v-if="attr.supplier">{{attr.supplier.name}}</span>
									</div>
								</div>
								<div class="different" v-for="attr in list.gives">
									<div class="thumb">
										<img :src="attr.pic_url" width="70px" height="70px" style="height: 70px">
										<div class="goods-text">
											<span>{{attr.product_name}}</span>
											<span>{{attr.sku_name}}</span>
										</div>
									</div>
									<div>
										<span>&nbsp;x&nbsp;{{attr.number}}</span>
									</div>
									<div>
										<span style="color: red">赠品</span>
									</div>
								</div>
							</div>
							<div>
								<span>{{list.buyer ? list.buyer.nick_name : ''}}</span>
								<span>{{list.buyer ? list.buyer.mobile : ''}}</span>
							</div>
							<div>
								<span> {{list.pay_type == 1 ? '微信支付' : '积分支付'}}</span>
							</div>
							<div>
								<span>￥{{list.actual_price}}</span>
							</div>
							<div>
								<span class="list-booton-edit clike-cursor" @click="edit(list.id)">查看详情</span>
<!--								<span class="list-booton-edit">物流信息</span>-->
							</div>
							<div>
								<span v-if="list.order_status == 1">待付款</span>
								<span v-else-if="list.order_status == 2">待发货</span>
								<span v-else-if="list.order_status == 3">待收货</span>
								<span v-else-if="list.order_status == 4">已完成</span>
								<span v-else-if="list.order_status == 5">用户取消</span>
								<span v-else-if="list.order_status == 6">系统取消</span>
								<span v-else>退货退款</span>
							</div>
						</div>
					</div>
					<div class="list-booton">
						<!-- <span>1级佣金 </span>&nbsp;0&nbsp;元&nbsp;
						<span>2级佣金 </span>&nbsp;0&nbsp;元&nbsp;
						<span class="list-booton-edit">修改佣金 </span> -->
					</div>
				</div>
			</div>
		</div>

		<el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page" :current-page.sync="pageNum"
			:page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
	</div>
</template>
<script>
	export default {
		name: 'index',
		data() {
			return {
				list: [],
				isLoad: false,
				pageNum: 0,
				pageSize: 20,
				total: 0,
				page: 1,
				// 查询
				item: {},
				options: [{
					id: 1,
					name: '自营',
				}, {
					id: 2,
					name: '非自营',
					children: []
				}],
				supplierId: ''
			}
		},
		created() {
			this.item = {
					page: this.page,
					limit: this.pageSize
				},
			this.loadList()
		},
		methods: {
			async loadList() {
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				let res = ''

				// 供应商列表
				res = await this.axios.get('/store/data/listSupplierForOrderSearch', {})
				this.$set(this.options[1], 'children', res.data)

				res = await this.axios.post('/store/order/receivedList', this.item)
				this.list = res.data.list.data
				this.total = res.data.list.total

				this.isLoad = !this.isLoad
			},
			// 传一个ID跳转到edit页面，进行编辑
			edit(id) {
				this.$router.push({
					path: '/Indent/list.html',
					query: {
						id: id
					}
				});
			},
			sizeReload(val) {
				this.item.pageSize = val
				this.loadList()
			},
			pageReload(val) {
				this.item.page = val
				this.loadList()
			},
			// 搜索查询
			submit() {
				if(this.supplierId.length==1 && this.supplierId[0] == 1){
					this.item.supplierId = ''
				}else if(this.supplierId.length==1 && this.supplierId[0] == 2){
					this.item.supplierId = 0
				}else{
					this.item.supplierId = this.supplierId[this.supplierId.length - 1]
				}

				this.pageNum = 1
				this.item.page = 1
				this.loadList()
			},
		}
	}
</script>
<style scoped>
	.list-box {
		width: 100%;
		background-color: #FFF;
	}

	.list-box .list-box-title {
		width: 100%;
		height: 50px;
		background-color: #f8f8f8;
		padding: 0 20px;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		margin-bottom: 30px;
	}

	.list-box-title span {
		width: 1px;
		flex-grow: 1;
		display: flex;
		justify-content: center;
	}

	.list-box-title span:first-child {
		flex-grow: 2;
		justify-content: space-between;
		text-indent: 40px;
	}

	.list-box .list-box-content {
		width: 100%;
		border: 1px solid #e5e5e5;
	}

	.list-box-content .list {
		width: 100%;
	}

	.list .list-title {
		width: 100%;
		height: 64px;
		background-color: #f7f7f7;
		padding-left: 30px;
		box-sizing: border-box;
		line-height: 64px;
		color: #9f8e8e;
	}

	.list-title span:first-child {
		font-weight: bold;
		margin-right: 20px;
		color: black;
	}

	.list .list-content-box {
		border-bottom: 1px solid #e5e5e5;
		margin: 0 20px;
	}

	.list-content-box .list-content {
		display: flex;
		flex-wrap: nowrap;
	}


	.list-content span {
		line-height: 1.5;
	}

	.list-content .different-box {
		flex-grow: 3;
		border-left: none !important;
	}

	.different-box .different {
		width: 100%;
		height: 120px;
		display: flex;
		flex-wrap: wrap;
		flex-direction: row;
		align-items: center;
	}

	.different>div {
		display: flex;
		width: 1px;
		flex-grow: 1;
		justify-content: center;
	}

	.different .thumb {
		display: flex;
		flex-direction: row !important;
		align-items: center;
	}

	.different .goods-text {
		display: flex;
		flex-direction: column;
		margin-left: 20px;
	}

	.text-line {
		line-height: 50px !important;
	}

	.list-content>div {
		width: 1px;
		flex-grow: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		border-left: 1px solid #e5e5e5;
	}

	.list .list-booton {
		width: 100%;
		height: 60px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		padding-right: 20px;
		box-sizing: border-box;
	}

	.list-booton span {
		font-weight: 600;
	}

	.list-booton-edit {
		color: #0027e3;
		cursor: pointer;
	}
</style>
